import script from "./BoxItems.vue?vue&type=script&setup=true&lang=js"
export * from "./BoxItems.vue?vue&type=script&setup=true&lang=js"

import "./BoxItems.vue?vue&type=style&index=0&id=1fae5575&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fae5575"]])

export default __exports__